import React, { useState, useRef, useEffect } from 'react';

const Companies = () => {
  const [isPaused, setIsPaused] = useState(false);

  const companies = [
    { 
      name: "Worthy Homes", 
      color: "#f3b33d"
    },
    { 
      name: "Reality Real Estate", 
      color: "#dff3ff"
    },
    { 
      name: "Tsehay Real Estate", 
      color: "#f6d69b"
    },
    { 
      name: "Metro Real Estate", 
      color: "#dff3ff"
    },
    { 
      name: "Hosea Real Estate", 
      color: "#f3b33d"
    }
  ];

  const allCompanies = [...companies, ...companies];

  // SVG Building Icon
  const BuildingIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="#f3b33d">
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
    </svg>
  );

  return (
    <>
      <style>
        {`
          .companies {
            background: linear-gradient(135deg, #0a0f1c 0%, #0c1120 100%);
            min-height: 45vh;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            overflow: hidden;
            padding: 2rem 1rem;
            opacity: 1;
            visibility: visible;
          }

          .companies-container {
            max-width: 1200px;
            margin: 0 auto;
            width: 100%;
            position: relative;
            z-index: 2;
          }

          .section-header {
            text-align: center;
            margin-bottom: 2rem;
            opacity: 1;
            visibility: visible;
          }

          .section-pre-title {
            color: #f3b33d;
            font-size: 0.8rem;
            font-weight: 400;
            letter-spacing: 0.2em;
            text-transform: uppercase;
            margin-bottom: 0.5rem;
            display: block;
            font-family: 'Comfortaa', cursive;
            opacity: 1;
            visibility: visible;
          }

          .section-header h2 {
            color: #ffffff;
            font-size: 2rem;
            font-weight: 500;
            margin-bottom: 0.5rem;
            line-height: 1.2;
            font-family: 'Cormorant Garamond', serif;
            opacity: 1;
            visibility: visible;
          }

          .section-header .accent {
            color: #f3b33d;
            font-weight: 600;
          }

          .logos-scroll-container {
            overflow: hidden;
            position: relative;
            padding: 0.5rem 0;
          }

          .logos-track {
            display: flex;
            gap: 1.5rem;
            animation: scrollLogos 35s linear infinite;
            padding: 0 1rem;
          }

          .logos-track:hover {
            animation-play-state: paused;
          }

          @keyframes scrollLogos {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(calc(-280px * 5 - 1.5rem * 5));
            }
          }

          .logo-item {
            min-width: 240px;
            height: 100px;
            background: rgba(255, 255, 255, 0.03);
            border: 1px solid rgba(255, 255, 255, 0.08);
            border-radius: 14px;
            display: flex;
            align-items: center;
            gap: 1.2rem;
            padding: 0 1.5rem;
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
            opacity: 1;
            visibility: visible;
          }

          .logo-item::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, 
              transparent, 
              rgba(243, 179, 61, 0.1), 
              transparent);
            transition: left 0.6s ease;
          }

          .logo-item:hover {
            transform: translateY(-4px);
            border-color: rgba(243, 179, 61, 0.3);
            background: rgba(255, 255, 255, 0.05);
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
          }

          .logo-item:hover::before {
            left: 100%;
          }

          .logo-display {
            width: 50px;
            height: 50px;
            background: rgba(243, 179, 61, 0.1);
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid rgba(243, 179, 61, 0.2);
            transition: all 0.3s ease;
            flex-shrink: 0;
            overflow: hidden;
            opacity: 1;
            visibility: visible;
          }

          .logo-item:hover .logo-display {
            transform: scale(1.1);
            background: rgba(243, 179, 61, 0.15);
            border-color: rgba(243, 179, 61, 0.4);
          }

          .company-name {
            color: #ffffff;
            font-size: 1rem;
            font-weight: 500;
            font-family: 'Comfortaa', cursive;
            white-space: nowrap;
            transition: all 0.3s ease;
            opacity: 1;
            visibility: visible;
          }

          .logo-item:hover .company-name {
            color: #f3b33d;
          }

          @media (max-width: 768px) {
            .companies {
              min-height: 35vh;
              padding: 1.5rem 1rem;
            }
            
            .section-header h2 {
              font-size: 1.7rem;
            }
            
            .logo-item {
              min-width: 200px;
              height: 85px;
              padding: 0 1.2rem;
            }
            
            .logo-display {
              width: 45px;
              height: 45px;
            }
            
            .company-name {
              font-size: 0.95rem;
            }
            
            @keyframes scrollLogos {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(calc(-200px * 5 - 1.5rem * 5));
              }
            }
          }

          @media (max-width: 480px) {
            .section-header h2 {
              font-size: 1.5rem;
            }
            
            .logos-track {
              gap: 1rem;
            }
            
            .logo-item {
              min-width: 180px;
              height: 75px;
            }
            
            .logo-display {
              width: 40px;
              height: 40px;
            }
          }
        `}
      </style>

      <section className="companies">
        <div className="companies-container">
          <div className="section-header">
            <span className="section-pre-title">Trusted Partners</span>
            <h2>
              Working With <span className="accent">The Best</span>
            </h2>
          </div>

          <div className="logos-scroll-container">
            <div 
              className="logos-track"
              onMouseEnter={() => setIsPaused(true)}
              onMouseLeave={() => setIsPaused(false)}
            >
              {allCompanies.map((company, index) => (
                <div
                  key={`${company.name}-${index}`}
                  className="logo-item"
                  style={{ '--accent-color': company.color }}
                >
                  <div className="logo-display">
                    <BuildingIcon />
                  </div>
                  <span className="company-name">{company.name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Companies;